import { differenceInDays } from 'date-fns'

export default ({ before = '', startedAt, after = '' }) => {
  return (
    <div className="days-count-wrapper">
      <div className="days-count">
        <div className="days-count-before"> {before} </div>
        <div className="days-count-days">
          {differenceInDays(new Date(), startedAt)} dias
        </div>
        <div className="days-count-after"> {after} </div>
      </div>
    </div>
  )
}
